/**
 * « Vu » that changes while the conversation is open, the live option of
 * « Ton mélange » (validated by Maude on 31/10/2026). Who read each message
 * was already stored and sent when a conversation opens; what is new is that
 * the others are told as soon as somebody reads, so « Vu » appears under the
 * last message without leaving and coming back.
 *
 * The app still marks messages read through POST /chats/read-messages, which
 * every published app calls. The API then tells the conversation's room which
 * of those messages this person had not read yet, and nothing at all when
 * there were none.
 */

export const MessagesRead = 'messages-read';
export const MessagesReadIn = (chatId: string) => `${MessagesRead}-${chatId}`;

export interface MessagesReadEvent {
  chatId: string;
  userId: string;
  messageIds: string[];
}
